import * as React from 'react';

import {Illustration} from 'shells/illustrations/illustration';
import {Body} from 'shells/typography/body';

export function NewUserSplashScreen() {
    return (
        <>
            <Body size='xlarge' isBold={true}>
                Welcome to Nutshell!
            </Body>
            <Body size='large'>
                We are so excited you joined us. It looks like your account needs some finalized
                touches. Please contact your admin to get proper access for an optimal Nutshell
                experience.
            </Body>
            <Illustration src='high-five' width={250} />
        </>
    );
}
